import React from 'react';
import EnquiryStatusBadge from './EnquiryStatusBadge';
import styles from './Enquiries.module.css';

const EnquiryRow = ({ enquiry, onRowClick }) => {
  const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A';
    if (timestamp.toDate) {
      return timestamp.toDate().toLocaleDateString();
    }
    return new Date(timestamp).toLocaleDateString();
  };

  const getDaysAgo = (timestamp) => {
    if (!timestamp) return '';
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays === 0) return 'Today';
    if (diffDays === 1) return 'Yesterday';
    return `${diffDays} days ago`;
  };

  const formatBudget = (budget) => {
    if (!budget) return 'Not specified';
    // Remove any existing £ symbol and format
    const cleanBudget = budget.toString().replace(/[£,]/g, '');
    // Check if it's a number
    if (!isNaN(cleanBudget)) {
      return `£${Number(cleanBudget).toLocaleString()}`;
    }
    // If budget contains text (like "10000-20000"), add £ to the beginning
    return `£${budget}`;
  };

  return (
    <tr onClick={() => onRowClick(enquiry.id)}>
      <td>
        <EnquiryStatusBadge status={enquiry.status} />
      </td>
      <td>
        <div className={styles.enquiryDetails}>
          <div className={styles.enquiryTitle}>
            {enquiry.projectName || 'Untitled Enquiry'}
          </div>
          {enquiry.enquiryDetails?.timeline && (
            <div className={styles.enquiryTimeline}>
              Timeline: {enquiry.enquiryDetails.timeline}
            </div>
          )}
        </div>
      </td>
      <td>
        <div className={styles.customerInfo}>
          <div className={styles.customerName}>
            {enquiry.customer?.name || 'Unknown Customer'}
          </div>
          {enquiry.customer?.email && (
            <div className={styles.customerEmail}>
              {enquiry.customer.email}
            </div>
          )}
        </div>
      </td>
      <td>
        <div className={styles.budgetCell}>
          {formatBudget(enquiry.enquiryDetails?.budget)}
        </div>
      </td>
      <td>
        <div className={styles.dateInfo}>
          <div className={styles.datePrimary}>
            {formatDate(enquiry.createdAt)}
          </div>
          <div className={styles.dateSecondary}>
            {getDaysAgo(enquiry.createdAt)}
          </div>
        </div>
      </td>
    </tr>
  );
};

export default EnquiryRow;